var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"badge",class:{ [_vm.yesBadgeClass]: _vm.value === true, [_vm.noBadgeClass]: _vm.value === false, [_vm.unknownBadgeClass]: _vm.value == null }},[_vm._v(" "+_vm._s(_vm.value === true? 'OUI' : _vm.value === false? 'NON' : '-'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }